import { useState } from 'react'
import { sendPost } from 'hooks/use-fetch'
import { Box, Button } from '@mui/material'
import { DatePickerWithLabel } from 'Components/DatePicker'
import { toast } from 'react-toastify'

export interface DateRangeOptionsProps {
  endpoint: string
}

export function DateRangeOptions (props: DateRangeOptionsProps): JSX.Element {
  const [startDate, setStartDate] = useState<Date | null>(null)
  const [endDate, setEndDate] = useState<Date | null>(null)

  const openReport = async (): Promise<void> => {
    if (startDate === null || endDate === null) {
      toast.error('Please enter required values.')
    } else {
      const { response, success } = await sendPost(`/Reporting/${props.endpoint}`, { startDate, endDate })
      if (success) {
        window.open(response, '_blank')?.focus()
      }
    }
  }

  return <>
    <Box className='mt-10'>
      <DatePickerWithLabel
        required={true}
        label='Start Date'
        name='startDate'
        onChange={setStartDate}
        value={startDate}
      />
      <DatePickerWithLabel
        required={true}
        label='End Date'
        name='endDate'
        onChange={setEndDate}
        value={endDate}
      />
    </Box>

    <Box className='mt-10'>
      <Button color='secondary' variant='contained' onClick={openReport}>Preview</Button>
    </Box>
  </>
}
